import React from "react";
import "../index.css";
import eart from '../assets/eart.png'
const CargoBox = ({ className = "" }) => (
    <svg
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M50 8 88 29 50 50 12 29 50 8Z"
            fill="#D9E4EF"
        />

        <path
            d="M12 29 50 50V92L12 71V29Z"
            fill="#8297AC"
        />

        <path
            d="M50 50 88 29V71L50 92V50Z"
            fill="#50677E"
        />

        <path
            d="M50 8 88 29 50 50 12 29 50 8Z"
            stroke="#FFFFFF"
            strokeOpacity=".55"
            strokeWidth="1.5"
        />

        <path
            d="M50 50V92M31 39V81M69 39V81"
            stroke="#FFFFFF"
            strokeOpacity=".3"
            strokeWidth="1.5"
        />

        <path
            d="M24 35 50 49 76 35"
            stroke="#FFFFFF"
            strokeOpacity=".3"
            strokeWidth="1.5"
        />
    </svg>
);

const ShippingContainer = ({ className = "" }) => (
    <svg
        className={className}
        viewBox="0 0 180 100"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M12 22 151 8 168 19 29 34 12 22Z"
            fill="#9CB4C8"
        />

        <path
            d="M12 22 151 8V77L12 91V22Z"
            fill="#246A91"
        />

        <path
            d="M151 8 168 19V87L151 77V8Z"
            fill="#174A6A"
        />

        {Array.from({ length: 9 }).map((_, index) => (
            <path
                key={index}
                d={`M${25 + index * 14} ${21 - index * 1.4}
                   V${89 - index * 1.4}`}
                stroke="#BBD1E1"
                strokeOpacity=".55"
                strokeWidth="2"
            />
        ))}

        <path
            d="M12 22 151 8 168 19 29 34 12 22Z"
            stroke="#D7E5EF"
            strokeOpacity=".6"
            strokeWidth="1.5"
        />

        <path
            d="M12 91 151 77"
            stroke="#BBD1E1"
            strokeOpacity=".5"
            strokeWidth="2"
        />
    </svg>
);

const Globe = () => (<div className="logistics-globe" aria-hidden="true"> <div className="logistics-globe-inner"> <img
    className="logistics-globe-photo"
    src={eart}
    alt=""
    draggable="false"
/> </div>

    <div className="logistics-globe-glow" />
</div>

);


const LogisticsBackground = () => {
    return (
        <div
            className="logistics-background"
            aria-hidden="true"
        >
            <div className="logistics-background-grid" />

            <div className="logistics-orbit logistics-orbit-one" />
            <div className="logistics-orbit logistics-orbit-two" />

            <Globe />

            <div className="logistics-cargo logistics-cargo-one">
                <CargoBox />
            </div>

            <div className="logistics-cargo logistics-cargo-two">
                <ShippingContainer />
            </div>

            <div className="logistics-cargo logistics-cargo-three">
                <CargoBox />
            </div>

            <div className="logistics-cargo logistics-cargo-four">
                <ShippingContainer />
            </div>

            <div className="logistics-cargo logistics-cargo-five">
                <CargoBox />
            </div>

            <div className="logistics-cargo logistics-cargo-six">
                <CargoBox />
            </div>

            <div className="logistics-route-dot logistics-route-dot-one" />
            <div className="logistics-route-dot logistics-route-dot-two" />
            <div className="logistics-route-dot logistics-route-dot-three" />
        </div>
    );
};

export default LogisticsBackground;